export default __webpack_public_path__ + "static/event_1-e7996e6af19b671e8c2660ee1ca5a91f.jpg";